<template>
  <div>
    <div
      v-for="(item, index) in approvalList"
      class="approval-list"
      :key="item.id"
    >
      <a-descriptions bordered>
        <a-descriptions-item label="审批意见">
          <a-badge v-if="item.status == 1" status="success" text="同意" />
          <a-badge v-else status="error" text="否决" />
        </a-descriptions-item>
        <a-descriptions-item label="审批人">
          {{ item.username }}
        </a-descriptions-item>
        <a-descriptions-item label="审批时间">
          {{ item.approveDate }}
        </a-descriptions-item>
        <a-descriptions-item label="备注" :span="3">
          <html-content :content="item.remark"></html-content>
        </a-descriptions-item>
        <a-descriptions-item
          label="跨级审批原因"
          :span="3"
          v-if="item.skipRemark"
        >
          {{ item.skipRemark }}
        </a-descriptions-item>
        <a-descriptions-item
          label="预警提交原因"
          :span="3"
          v-if="item.confirmRiskRemark"
        >
          {{ item.confirmRiskRemark }}
        </a-descriptions-item>
        <a-descriptions-item
          label="附件"
          :span="3"
          v-if="item.attachments.length > 0"
        >
          <a
            class="attachment-link"
            v-for="attachment in item.attachments"
            :key="attachment.id"
            herf="javascript:;"
            @click="handleDownload(attachment.id)"
          >
            {{ attachment.fileName }}
          </a>
        </a-descriptions-item>
      </a-descriptions>
      <a-divider v-if="index != approvalList.length - 1" />
    </div>
  </div>
</template>

<script>
import HtmlContent from './HtmlContent.vue'
import { downloadAttachment } from '../api'

export default {
  name: 'ApprovalRemarkList',
  data() {
    return {}
  },
  props: ['approvalList', 'title'],
  methods: {
    handleDownload(id) {
      downloadAttachment(id)
    },
  },
  components: {
    HtmlContent,
  },
}
</script>

<style lang="less" scoped>
.approval-list {
  .attachment-link {
    display: block;
    padding: 10px;
  }
}
</style>
